export const capitalize = (str) => {
    return str[0].toUpperCase() + str.substring(1, str.length)
}


// WEBPACK FOOTER //
// ./src/utils/string.js